import React from "react";
import GridLayout from "react-grid-layout";
import { NavLink } from "react-router-dom";
import { saveToLS, getFromLS } from "../utils/localstorage";
import { randomInt } from "../utils/randomInt";
import { site_tags_address } from "../constants.js";
import InfoButton from "./info_button.jsx";


export default class ArticleGrid extends React.Component 
{
  // INFO: If you see the default values, you're doing it wrong.
  // Pass values in through the props passes when creating the ArticleGrid Element 
  static defaultProps = {
    rowHeight:30,
    cols:5,
  };

  constructor(props) {
    super(props);

    this.state = {
      gridID: props.gridID,
      layout: [],
      tags: [],
      items: [],
      onLayoutChange: function() {},
      resetLayout: function() {},
      defaultSize: props.defaultSize,
      fullSize: props.fullSize,
    }

    // Attempt to load the layout from local storage, on failure just default the layout.
    // gridID is used as the filename.
    // TODO: uncomment this to allow layout loading from local storage
    try {
      this.state.layout = JSON.parse(JSON.stringify(getFromLS(props.gridID)));
    } catch (e) {
      // Json load failed, reseting to default
    }

    this.onLayoutChange = this.onLayoutChange.bind(this);
    this.resetLayout = this.resetLayout.bind(this);
  }

  componentDidMount()
  {
    this.filterByTags(this.props.tags);
    this.forceUpdate();
    console.log(this.state);
    console.log(this.props);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.tags !== this.props.tags)
    {
      this.setState({tags: this.props.tags});
      this.filterByTags(this.props.tags);
    }
  }

  suppressParentMouseDown(e) {
    e.stopPropagation();
  }

  //TODO: CSS update
  createElement(el) 
  {
    if (!el.hidden)
    {
      return (
        <div className="article-bk" key={el.i} data-grid={{x:0, y:0, w:this.state.defaultSize[0], h:this.state.defaultSize[1], minH:1}}>
          <div className="article-title mobileSelectionBorder1"
          onDoubleClick={this.onFullscreenItem.bind(this, el.i)} //Hack: Only works on desktop
          onTouchStart={this.onTryMoveItem_Mobile.bind(this, el.i, true)} //HACK: issues with mobile
          >{el.data.title}</div>
          <div className="article-html-render-area" 
          onMouseDown={this.suppressParentMouseDown} // Allows default mouse behaviour in body of article
          onTouchStart={this.onTryMoveItem_Mobile.bind(this, el.i, false)} //HACK: issues with mobile
          dangerouslySetInnerHTML={{__html:el.data.body}}/>
          <div className="grid-item-remove-icon" onPointerDown={this.onRemoveItem.bind(this, el.i)} >
            <img src="icons/svg/remove_icon.svg" style={{width:25 + 'px'}} alt="remove"/>
          </div>
          <NavLink to={"/?tags="+el.i}className="grid-item-focus-icon">
            <img src="icons/svg/focus_25.svg" style={{width:25 + 'px'}} alt="remove"/>
          </NavLink>
          <InfoButton uuid={el.i} date={el.data.mdate} tags={el.data.tags}></InfoButton>
        </div>
      );
    }
    return;
  }
  
  // HACK: this is absolute bullshit.
  // React/gridlayout for whatever reason doesn't see setting this to [] as an update world rendering,
  // except the first time! So it only works once, unless I pump it with some semi-unique, bullshit value.
  resetLayout() 
  {
    this.setState({ layout: [{
      'x':0, 
      'y':0, 
      'w':0, 
      'h':0, 
      'id':'dummy', 
      'random': randomInt() }] });
  }

  onLayoutChange(newLayout) {
    saveToLS(this.state.gridID, [...newLayout]);
    this.setState({layout: newLayout});
  }

  onRemoveItem(ID) {
    // TODO: refactor duplicated boilerplate
    // TODO: refactor, (this can't be the best way to remove an item from an array can it?)
    // Remove the element from items
    function removeItem(value, index, arr) {
      if (value.data.id === ID) {
        arr.splice(index, 1);
      }
    }
    this.state.items.filter(removeItem);

    // Remove the element from the layout
    var updatedLayout = [...this.state.layout];
    function removeLayoutItem(value, index, arr) {
      if (value.i === ID) {
        arr.splice(index, 1);
      }
    }
    updatedLayout.filter(removeLayoutItem)

    this.forceLayoutUpdate(updatedLayout);

    this.setState({ layout: updatedLayout }); 
  }

  // HACK: this is a mess, see inside for comments
  onFullscreenItem(ID)
  {
    // Increase size of selected element
    // HACK: syncing layout between this class, the underlying grid, and local storage.
    // Find the clicked on element,
    // Increase that element to fullscreen size,
    // Push a fake element so when setState is called, it (react andor the underlying grid) thinks there has been a change,
    // Call setstate to update the layout.
    let updatedLayout = [...this.state.layout];

    for (let i = 0; i < updatedLayout.length; i++)
    {
      if (updatedLayout[i].i === ID) {
        updatedLayout[i].x = 0;
        updatedLayout[i].y = 0;
        updatedLayout[i].h = this.state.fullSize[1];
        updatedLayout[i].w = this.state.fullSize[0];
      }
      else
      {
        updatedLayout[i].y = updatedLayout[i].y + 1; // Make room for the fullsized element at the top of the grid.
      }
    }

    this.forceLayoutUpdate(updatedLayout);
  }

  // If it's not the header, turn the element undraggable
  // Hack: this "fixes" a library bug. Because of the way touch is being handled, it can't be
  //  turned off in the children, so the functionality of selecting text by disabling
  //  onmousedown does not work on mobile even using the equivalent ontouchstart.
  onTryMoveItem_Mobile(ID, IsTitle) {
    let updatedLayout = [...this.state.layout];

    for (let i = 0; i < updatedLayout.length; i++) {
      if (updatedLayout[i].i === ID) {
        updatedLayout[i].isDraggable = IsTitle;
      }
    }

    this.forceLayoutUpdate(updatedLayout);
  }

  // HACK: slowest part of the whole process.
  // NxAxM where number of filters, number of articles, number of tags on each article
  filterByTags(filterTags)
  {
    var root = site_tags_address; // TODO: move to a constants file (1234 is port for local postgres testing server)
    var tagsPrefix = 'tags=';
    var ntagsPrefix = '&ntags=';
    var tags = '';
    var ntags = '';

    for (let k = 0; k < filterTags.length; k++)
    {
      if (!this.bIsNegativeTag(filterTags[k]))
      {
        tags += filterTags[k] + ',';
      }
      else
      {
        ntags += filterTags[k].substring(1) + ',';
      }
    }

    var requestString = filterTags.length === 0 ? root : root + tagsPrefix + tags + ntagsPrefix + ntags;
    
    console.log(requestString);

    this.setLoading(true);
    fetch(requestString)
    .then(response => response.json())
    .then(data => {
      this.setState
      (
        { items: data.map(function(item)
          {
            return {
              i: item["id"],
              data: item,
              hidden: false, // If true, do not render the article
              rand: randomInt() // Set value fodder for forcing renders when I don't want to change values
            };
          })
        }
      );
    })
    .catch(error => console.error(error))
    .finally(() => {this.setLoading(false)});
  }

  bIsNegativeTag(tag)
  {
    return tag[0] === '-';
  }

  //HACK: may be slow
  trimTag(tag)
  {
    if (tag[0] === '-' || tag[0] === '+')
      return tag.substring(1);

    return tag;
  }

  // HACK: this can be simplified, but I'm not sure what part is triggering the update.
  forceLayoutUpdate(newLayout)
  {
    let updatedLayout = [...newLayout];

    //TODO: split this code out into a, no really, REALLY update the fucking layout
    if (updatedLayout.length > 0 && updatedLayout[updatedLayout.length - 1].i === 'dummy')
    updatedLayout.splice(updatedLayout.length, 1);

    // Push a fake element.
    updatedLayout.push(
      {'x':0, 
      'y':0, 
      'w':0, // 0 w/h will not render element
      'h':0, 
      'i':'dummy', // Allow finding and removing this element
      'random': randomInt}); // Ensure array changes
    
    this.setState({ layout: [...updatedLayout] }); //async
  }

  setLoading(state)
  {
    this.setState({ loading: state});
  }

  getLoading()
  {
    if (this.state.loading === true)
      return <div className="grid-loading"></div>;
  }

  render() {
    return (
      <div>
        <button className="grid-reset" onClick={this.resetLayout}></button>
        {this.getLoading()}
        <GridLayout {...this.props} layout={this.state.layout} onLayoutChange={this.onLayoutChange}>
          {this.state.items.map(el => this.createElement(el))}
        </GridLayout>
      </div>
    );
  }
}